import Banner from "../../sections/common/banner";
import SectionPricing2 from "../../sections/company/pricing/section-pricing2";
import { bannerData } from "../../../globals/banner";
import { useEffect } from "react";
import { loadScript } from "../../../globals/constants";

function PricingPage() {

    useEffect(()=>{
        loadScript("js/custom.js")
    })

    return (
        <>
            <Banner _data={bannerData.pricing} />
            <SectionPricing2 />
            {/* <SectionAboutCompany1 /> */}
            {/* <SectionVideo3 _data={video.pricing} /> */}
            {/* <SectionWhyChooseUs3 /> */}
            {/* <SectionClients2 /> */}
        </>
    )
}

export default PricingPage;